import { observer } from 'mobx-react-lite'
import { AuthLayout } from 'shared/layout'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useReCaptchaContext } from 'entities/Auth'

import { RegisterMultiorgStore } from 'pages/register/pages/registerMultiorg/ui/RegisterMultiorg/store/registerMultiorgStore'
import { useEventRegisterOrganizationError } from 'pages/register/pages/registerMultiorg/ui/RegisterMultiorg/events/EventRegisterOrganizationError'
import { useEventTokenCreated } from 'pages/register/pages/registerMultiorg/ui/RegisterMultiorg/events/EventTokenCreated'
import { RegisterMultiorgForm } from 'pages/register/pages/registerMultiorg/ui/RegisterMultiorg/ui/RegisterMultiorgForm/RegisterMultiorgForm'
import { RegisterMultiorgFormBottom } from './RegisterMultiorgFormBottom/RegisterMultiorgFormBottom'
import styles from './styles.module.scss'

type IRegisterMultiorgContentProps = {
  store: RegisterMultiorgStore
}

export const RegisterMultiorgContent = observer(({ store }: IRegisterMultiorgContentProps) => {
  useEventRegisterOrganizationError(store)
  useEventTokenCreated(store)

  if (store.preloading) {
    return (
      <div className={styles.wrap}>
        <SpinnerLoader ariaLabel={'RegisterMultiorg'} />
      </div>
    )
  }

  return (
    <div className={styles.wrap}>
      <AuthLayout
        title={'Start your 14-day trial'}
        subtitle={<div className={styles.subtitle}>Get started in just 30 seconds</div>}
        formBottom={<RegisterMultiorgFormBottom />}
        form={<RegisterMultiorgForm store={store} />}
      />
    </div>
  )
})

export const RegisterMultiorg = () => {
  const entities = useEntitiesContext()
  const storeReCaptcha = useReCaptchaContext()
  const store = new RegisterMultiorgStore(entities, storeReCaptcha)

  return <RegisterMultiorgContent store={store} />
}

export default RegisterMultiorg
